<template>
  <div class="execution-row" :class="{ 'is-open': open }">
    <div class="execution-row-header" @click="$emit('toggle')">
      <v-icon size="18" class="chevron" :class="{ 'is-open': open }">
        mdi-chevron-right
      </v-icon>
      <div class="execution-row-col execution-row-date">
        <span class="col-label">Data</span>
        {{ execution.date }}
      </div>
      <div class="execution-row-col execution-row-time">
        <span class="col-label">Início</span>
        {{ execution.start }}
      </div>
      <div class="execution-row-col execution-row-time">
        <span class="col-label">Término</span>
        {{ execution.end || "—" }}
      </div>
      <div class="execution-row-col execution-row-duration">
        <span class="col-label">Duração</span>
        {{ execution.duration }}
      </div>
      <div class="execution-row-col execution-row-status">
        <span class="col-label">Status</span>
        <StatusChip :status="execution.status" />
      </div>
      <div class="execution-row-col execution-row-qty">
        <span class="col-label">Processado</span>
        {{ execution.qty }}
      </div>
    </div>
    <v-expand-transition>
      <div v-if="open" class="execution-row-logs">
        <p v-if="loading" class="execution-row-loading">Carregando logs…</p>
        <LogTimeline v-else :logs="execution.logs || []" />
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
import StatusChip from "@/components/StatusChip/StatusChip.vue";
import LogTimeline from "@/views/Dashboard/Partials/LogTimeline/LogTimeline.vue";

export default {
  name: "ExecutionRow",
  components: { StatusChip, LogTimeline },
  props: {
    execution: { type: Object, required: true },
    open: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
};
</script>

<style src="./styles.scss" scoped lang="scss" />
